var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2AB3C9A7-5BD8-4F9C-A16F-BEB51C073EED-17830-0009432B630E64A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2 2 16 2 16 16 2 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inventory",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inventory-view-(w-Images)",
    transform: "translate(-9.000000, -220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-/-sidenav-/-expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leads",
    transform: "translate(0.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Help",
    transform: "translate(9.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5235,12.6551667 L9,11.3059167 L6.4765,12.6545833 L6.97991667,9.83766667 L4.91666667,7.85491667 L7.75166667,7.46408333 L9,4.88866667 L10.24775,7.46408333 L13.0833333,7.85491667 L11.0200833,9.83825 L11.5235,12.6551667 Z M9,2 C5.13425,2 2,5.13425 2,9 C2,12.86575 5.13425,16 9,16 C12.86575,16 16,12.86575 16,9 C16,5.13425 12.86575,2 9,2 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/Leads.922442498946c5cc09a0c81b6c190b5e.svg";
export { ForwardRef as ReactComponent };